"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchPublicMetaData = void 0;

var _ActionTypes = _interopRequireDefault(require("pricing-pages-unified-ui/constants/ActionTypes"));

var _dispatchAndThrowError = require("pricing-pages-unified-ui/utils/dispatchAndThrowError");

var _CountryToCurrency = _interopRequireDefault(require("pricing-pages-unified-ui/constants/CountryToCurrency"));

var _PublicMetaDataApi = require("pricing-pages-unified-ui/api/public-only/PublicMetaDataApi");

// temp formatting until reponse comes back this way from EE to match with in-app onboarding response
var formatRequiredOnboarding = function formatRequiredOnboarding(payload) {
  var formattedObj = {};
  Object.keys(payload).map(function (merchId) {
    return formattedObj[merchId] = {
      merchandiseId: merchId,
      onboardingMerchandiseId: payload[merchId],
      onboardingRequired: true
    };
  });
  return formattedObj;
};

var fetchPublicMetaData = function fetchPublicMetaData() {
  return function (dispatch) {
    dispatch({
      type: _ActionTypes.default.PUBLIC_META_DATA_REQUESTED
    });
    return (0, _PublicMetaDataApi.getPublicMetaData)().then(function (resp) {
      dispatch({
        type: _ActionTypes.default.PUBLIC_META_DATA_RECEIVED
      });
      var country = resp.country,
          promotions = resp.promotions,
          requiredOnboarding = resp.requiredOnboarding,
          phoneNumbers = resp.phoneNumbers,
          featureFlags = resp.featureFlags;
      var formattedRequiredOnboarding = formatRequiredOnboarding(requiredOnboarding); // TODO: once in-app can get countryCode too,
      // just use countryCode instead of full country string

      dispatch({
        type: _ActionTypes.default.COUNTRY_RECEIVED,
        payload: {
          country: country
        }
      }); // TODO: Get currency from this endpoint too so we can kill this map

      var currency = _CountryToCurrency.default[country];

      if (currency) {
        dispatch({
          type: _ActionTypes.default.ACTIVE_CURRENCY_CODE_UPDATED,
          payload: {
            currency: currency
          }
        });
      }

      dispatch({
        type: _ActionTypes.default.ELIGIBLE_PROMOTIONS_RECEIVED,
        payload: promotions
      });
      dispatch({
        type: _ActionTypes.default.REQUIRED_ONBOARDING_RECEIVED,
        payload: formattedRequiredOnboarding
      });
      dispatch({
        type: _ActionTypes.default.PHONE_NUMBERS_RECEIVED,
        payload: {
          phoneNumbers: phoneNumbers
        }
      });
      dispatch({
        type: _ActionTypes.default.PUBLIC_FEATURE_FLAGS_RECEIVED,
        payload: {
          featureFlags: featureFlags
        }
      });
    }).catch(function (error) {
      (0, _dispatchAndThrowError.dispatchAndThrowError)({
        dispatch: dispatch,
        type: _ActionTypes.default.PUBLIC_META_DATA_FAILED,
        error: error
      });
    });
  };
};

exports.fetchPublicMetaData = fetchPublicMetaData;


//////////////////
// WEBPACK FOOTER
// ./js/actions/public-only/PublicMetaDataActions.js
// module id = 971
// module chunks = 6